import React from 'react';

import Modal from '../../../common/modal/Modal';
import { SaveButton } from '../../../common/button/save-button/SaveButton';

export const DeleteFormModal = ({ closeModal, handleConfirmRemoveForm }) => {
  return (
    <Modal
      closeModal={closeModal}
      setIsModalOpen={closeModal}
      headerTitle="Delete Form"
      hideButton
      width="540px"
      height="max-content"
      contentPadding="20px"
      justifyContent="center"
    >
      <div className="visit-pack-warning-modal">
        <p className="visit-pack-warning-modal-message">Please note:</p>
        <p className="visit-pack-warning-modal-message">
          Deleting a form will not remove that form from visits that have been logged. It will only prevent the form
          from being added to future studies and visits.
        </p>

        <div className="visit-pack-warning-modal-buttons">
          <SaveButton
            color="#ffffff"
            border="1px solid #6f8695"
            textColor="#6f8695"
            title="Cancel"
            onClick={closeModal}
          />
          <SaveButton
            color="#6f8695"
            border="1px solid #6f8695"
            textColor="#ffffff"
            title="Delete"
            onClick={handleConfirmRemoveForm}
          />
        </div>
      </div>
    </Modal>
  );
};
